import 'bootstrap/js/dist/modal';

(function($) {
    if ($('.video-modal__link--button').length > 0) {
        $('.video-modal__link--button').on('click', function(e) {
            e.preventDefault();
        });
    }

    $('.modal').on('hide.bs.modal', function() {
        const backupVideoClose = $(this).html();
        $(this).html(backupVideoClose);
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
    });
})(jQuery);
